import React from "react";
import { Alert, Snackbar } from "@mui/material";
import { NotificationParams } from "../../types/common";

interface Props {
    notification: NotificationParams;
    openSnackbar: boolean;
    setOpenSnackbar: (value: boolean) => void;
}

const CustomSnackbar = ({ notification, openSnackbar, setOpenSnackbar }: Props) => {
    const handleCloseSnackbar = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackbar(false);
    };

    return (
        <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
            <Alert onClose={handleCloseSnackbar} severity={notification.severity} sx={{ width: "100%" }}>
                {notification.message}
            </Alert>
        </Snackbar>
    );
};

export default CustomSnackbar;
